import { RefObject, useEffect, useState } from 'react';

const MAX_FILTERS_WIDTH = 970;

interface IFilter {
  id: string;
}

/**
 * Хук для определения, нужно ли сжимать фильтры.
 *
 * Вычисляет суммарную ширину двух Group-компонентов внутри контейнера фильтров.
 * Если суммарная ширина превышает MAX_FILTERS_WIDTH (970px), возвращает true,
 * что сигнализирует о необходимости применить компактный вид для FilterButtonV2.
 *
 * @param filtersRef - ref на контейнер с фильтрами, содержащий два Group-элемента
 * @param filters - массив фильтров, используется для пересчёта при изменении набора фильтров
 * @returns isNarrow - флаг, указывающий на необходимость сжатия фильтров
 */
export const useIsNarrowFilters = (filtersRef: RefObject<HTMLDivElement>, filters: IFilter[]): boolean => {
  const [isNarrow, setIsNarrow] = useState(false);

  useEffect(() => {
    const filtersElement = filtersRef.current;

    if (!filtersElement) {
      return;
    }

    const calculateGroupsWidth = () => {
      const groups = Array.from(filtersElement.children) as HTMLElement[];

      if (groups.length < 2) {
        setIsNarrow(false);

        return;
      }

      const [firstGroup, secondGroup] = groups;

      const { width: firstGroupWidth } = firstGroup.getBoundingClientRect();
      const { width: secondGroupWidth } = secondGroup.getBoundingClientRect();

      const marginLeft = parseInt(getComputedStyle(secondGroup).marginLeft, 10) || 0;

      const totalWidth = firstGroupWidth + secondGroupWidth + marginLeft;

      setIsNarrow(totalWidth > MAX_FILTERS_WIDTH);
    };

    calculateGroupsWidth();
  }, [filtersRef, filters]);

  return isNarrow;
};
